import * as React from "react";
import { useEffect } from "react";
import NewMeasuresService from "@app/projects/network-assessment/network-performance/newMeasuresService";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { QESButton } from "@app/shared/qes-standards/Button";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";
import NetworkPerformanceDistribution from "@app/projects/network-assessment/network-performance/NetworkPerformanceDistribution";
import SpeedometerGauge from "@app/projects/SpeedometerGauge";


const NetworkPerformancePage = (): React.ReactElement => {

  const newMeasuresService = new NewMeasuresService();

  // Remove this useEffect once implementation begins. Just added for testing purposes
  useEffect(() => {
    newMeasuresService.getNewMeasuresConnectionTest().then((data) => {
      console.log(data);
    });
  }, []);

  const serviceAreaItems: DropdownItem<string>[] = [
    { key: "1", name: "Florida" },
    { key: "2", name: "Georgia" },
    { key: "3", name: "South Carolina" }
  ];

  const specialtyItems: DropdownItem<string>[] = [
    { key: "1", name: "Primary Care" },
    { key: "2", name: "Chiropractor" },
    { key: "", name: "Dermatology" }
  ];

  const onApplyFiltersClick = (): void => { };
  const onClearFiltersClick = (): void => { };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-12">
          <div className="card card-static">
            <div className="card-body">
              <div className="row">
                <div className="col-12">
                  <label className="label-m mb-2">Filters</label>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <MultiselectDropdown
                    items={serviceAreaItems}
                    label="Service Area"
                    testId="network-performance__filters--service-area"
                    selectedItems={serviceAreaItems}
                  >
                  </MultiselectDropdown>
                </div>
                <div className="col-md-2">
                  <MultiselectDropdown
                    items={specialtyItems}
                    label="Specialties"
                    testId="network-performance__filters--specialties"
                    selectedItems={specialtyItems}
                  >
                  </MultiselectDropdown>
                </div>
                <div className="col-md-2 d-flex align-items-end">
                  <div className="w-100">
                    <QESButton
                      disabled={true}
                      className="pb-0"
                      onClick={() => onClearFiltersClick()}
                      qesTestId="network-performance__filters--clear-button"
                      qesType="secondary-danger"
                    >
                      Clear All
                    </QESButton>
                    <QESButton
                      className="btn btn-primary"
                      onClick={() => onApplyFiltersClick()}
                      qesTestId="network-performance__filters--search-button"
                    >
                      Search
                    </QESButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <DashboardTile
          classNames="network-performance__cost-tile"
          title={""}
          widthClass="col-md-3"
        >
          <SpeedometerGauge
            label="Cost"
            maxValue={5}
            scores={{ benchmarkScore: 3.9, networkScore: 4.2, scenarioScore: 1.5 }}
            key="cost-speedometer"
          />

          <NetworkPerformanceDistribution />
        </DashboardTile>

        <div className="col-md-1"></div>

        <DashboardTile
          classNames="network-performance__cost-tile"
          title={""}
          widthClass="col-md-3"
        >
          <SpeedometerGauge
            label="Quality"
            maxValue={5}
            scores={{ benchmarkScore: 1.2, networkScore: 2, scenarioScore: .5 }}
            key="quality-speedometer"
          />
          <NetworkPerformanceDistribution />
        </DashboardTile>

        <div className="col-md-1"></div>

        <DashboardTile
          classNames="network-performance__cost-tile"
          title={""}
          widthClass="col-md-3"
        >
          <SpeedometerGauge
            label="Marketability"
            maxValue={100}
            scores={{ benchmarkScore: 55, networkScore: 32, scenarioScore: 79 }}
            key="marketability-speedometer"
          />
          <NetworkPerformanceDistribution />
        </DashboardTile>
      </div>
    </React.Fragment>
  );
};

export { NetworkPerformancePage };
